import { Validators, FormArray } from '@angular/forms';

export class FormBaseClass {
    constructor() { }

    setValidations(form, fieldObj) {
        // Set all validations
        this.setAllValidation(form, fieldObj);
        // Check enable disable input.
        this.setEnabledDisabledField(form, fieldObj);
    }

    setAllValidation(form, fieldObj) {
        const validations = [];
        const control = form.controls[fieldObj.key];

        if (fieldObj.validators && fieldObj.validators.required) {
            validations.push(Validators.required);
        }

        if (fieldObj.validators && fieldObj.validators.min_length) {
            validations.push(Validators.minLength(fieldObj.validators.min_length));
        }

        if (fieldObj.validators && fieldObj.validators.max_length) {
            validations.push(Validators.maxLength(fieldObj.validators.max_length));
        }

        if (fieldObj.validators && fieldObj.validators.min) {
            validations.push(Validators.min(fieldObj.validators.min));
        }

        if (fieldObj.validators && fieldObj.validators.max) {
            validations.push(Validators.max(fieldObj.validators.max));
        }

        if (fieldObj.validators && fieldObj.validators.pattern) {
            validations.push(Validators.pattern(fieldObj.validators.pattern));
        }
        setTimeout(() => {
            control.setValidators(validations);
            control.updateValueAndValidity();
        }, 1);
    }

    setEnabledDisabledField(form, fieldObj) {
        if (fieldObj.templateOptions && fieldObj.templateOptions.disabled) {
            form.get(fieldObj.key).disable();
        }
    }

}
